import {AxiosRequestConfig} from 'axios';
import request from '../../axios';

export const deleteUserProfile = async (guid: string, profile_type: string) => {
  const {data}: {data: IResponse} = await request.delete(
    `/api/profile/profile-image/${guid}`,
    {
      data: {profile_type},
    } as AxiosRequestConfig,
  );
  return data;
};
